import { BREAKPOINTS } from '../../../../assets/js/breakpoints';
import { attachSwipeEvents, throttle } from '../../utils';

const initCarousel = (carousel, { perviewXs, perviewSm, perviewMd, perviewLg, perviewXl, length }) => {
  const inner = carousel.querySelector('.js-carousel-inner');
  const nav = carousel.querySelector('.js-carousel-nav');
  const prev = carousel.querySelector('.js-carousel-prev');
  const next = carousel.querySelector('.js-carousel-next');
  let counter = 0;

  const state = {
    _currentSlide: 0,
    get currentSlide() {
      return this._currentSlide;
    },
    set currentSlide(i) {
      this._currentSlide = i;
      this.update();
    },
    _perview: 0,
    get perview() {
      return this._perview;
    },
    set perview(i) {
      this._perview = i;
      this.updateNav();
      this.update();
    },
    updateNav() {
      const perview = this._perview;
      const controls = carousel.querySelector('.js-carousel-controls');

      if (controls && nav) {
        if (perview >= length) {
          controls.style.display = 'none';
        } else {
          while (nav.firstChild) {
            nav.removeChild(nav.lastChild);
          }

          const createItem = (i) => {
            const item = document.createElement('div');

            item.classList.add('m-carousel__nav-item');
            item.setAttribute('data-index', i);
            item.setAttribute('data-counter', counter);
            item.setAttribute('role', 'tab');
            item.setAttribute('tabindex', '0');
            item.setAttribute('aria-label', `Aller au slide ${i + 1}`);
            counter++;

            item.addEventListener('click', () => this.currentSlide = i);
            item.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.currentSlide = i;
              }
            });

            return item;
          };

          for (let i = 0; i <= length - perview; i++) {
            nav.append(createItem(i));
          }

          controls.style.display = 'flex';
        }
      }

      this._currentSlide = Math.max(0, Math.min(length - this._perview, this._currentSlide));
    },
    update() {
      const i = this._currentSlide;
      const perview = this._perview;
      const slides = inner.querySelectorAll('.js-carousel-slide');

      for (const slide of slides) {
        slide.style.width = `calc((100% - ${perview - 1} * 32px) / ${perview})`;
      }

      if (i >= 0 && i < length - (perview - 1)) {
        inner.style.transform = `translateX(calc(-${i} * ( 100% - ${perview - 1} * 32px) / ${perview} - ${i} * 32px))`;

        for (const n of nav.children) {
          const isActive = parseInt(n.getAttribute('data-index')) === i;

          n.classList.toggle('active', isActive);
          n.setAttribute('aria-selected', isActive.toString());
        }
      }

      if (i === 0) {
        prev.classList.add('-disabled');
      } else {
        prev.classList.remove('-disabled');
      }

      if (i === length - perview) {
        next.classList.add('-disabled');
      } else {
        next.classList.remove('-disabled');
      }
    },
  };

  const handlePrev = () => {
    if (state.currentSlide > 0) {
      state.currentSlide--;
    }
  };

  const handleNext = () => {
    if (state.currentSlide < length - state.perview) {
      state.currentSlide++;
    }
  };

  const handleResize = () => {
    const W = window.innerWidth;

    if (W <= BREAKPOINTS.xs && state.perview !== perviewXs) {
      state.perview = perviewXs;
    }

    if (W > BREAKPOINTS.xs && W <= BREAKPOINTS.sm && state.perview !== perviewSm) {
      state.perview = perviewSm;
    }

    if (W > BREAKPOINTS.sm && W <= BREAKPOINTS.md && state.perview !== perviewMd) {
      state.perview = perviewMd;
    }

    if (W > BREAKPOINTS.md && W <= BREAKPOINTS.lg && state.perview !== perviewLg) {
      state.perview = perviewLg;
    }

    if (W > BREAKPOINTS.lg && state.perview !== perviewXl) {
      state.perview = perviewXl;
    }
  };

  prev.addEventListener('click', handlePrev);
  next.addEventListener('click', handleNext);

  // Keyboard accessibility
  const handleKeydown = (handler) => (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handler();
    }
  };

  prev.addEventListener('keydown', handleKeydown(handlePrev));
  next.addEventListener('keydown', handleKeydown(handleNext));

  attachSwipeEvents(inner, {
    onSwipeLeft: handleNext,
    onSwipeRight: handlePrev,
  });

  window.addEventListener('resize', throttle(handleResize, 100));

  handleResize();
};

const Carousel = () => {
  const carousels = document.querySelectorAll('.js-carousel');

  for (const carousel of carousels) {
    const length = parseInt(carousel.dataset.length);
    const perviewXl = parseInt(carousel.dataset.perviewXl);
    const perviewLg = parseInt(carousel.dataset.perviewLg) || perviewXl;
    const perviewMd = parseInt(carousel.dataset.perviewMd) || perviewXl;
    const perviewSm = parseInt(carousel.dataset.perviewSm) || perviewXl;
    const perviewXs = parseInt(carousel.dataset.perviewXs) || perviewXl;

    initCarousel(carousel, { perviewXs, perviewSm, perviewMd, perviewLg, perviewXl, length });
  }
};

export default Carousel;
